import { render, staticRenderFns } from "./FormFeedback.vue?vue&type=template&id=0dc71140&scoped=true&"
import script from "./FormFeedback.vue?vue&type=script&lang=js&"
export * from "./FormFeedback.vue?vue&type=script&lang=js&"
import style0 from "./FormFeedback.vue?vue&type=style&index=0&id=0dc71140&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc71140",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DadataInput: require('/var/www/ct-frontend/ct-front-20261029043307/components/dadata/DadataInput.vue').default})
